import {
  getAXRuntimeActionFeed,
} from './AXRuntimeActionFeed';

export interface AXRuntimeGuardResult {
  readonly allowed: boolean;
  readonly action: 'continue' | 'redirect' | 'deny';
  readonly governor: string;
  readonly reason: string;
  readonly evaluatedAt: string;
}

export function executeAXRuntimeGuard():
AXRuntimeGuardResult {

  const feed = getAXRuntimeActionFeed();

  return Object.freeze({
    allowed: feed.action === 'continue',
    action: feed.action,
    governor: feed.governor,
    reason: feed.reason,
    evaluatedAt: feed.generatedAt,
  });
}
